<template>
  <Section>
    <ManageLiveSourceModal
      v-if="isShowChangeSourceModal"
      :live="currentVideo"
      :onClose="onCloseModal"
      :onEditSource="onPreviewSource">
      <h5 slot="header-title">เปลี่ยนลิงก์ถ่ายทอดสด</h5>
      <span slot="button-text">บันทึก</span>
    </ManageLiveSourceModal>
    <!-- <CreateLiveModal
      v-if="uploadModal"
      :onClose="onCloseModal"
      :onVideoChange="onVideoChange"
      :onDeleteVideo="onDeleteVideo"
      :isEdit="true"/> -->
    <template v-slot:section-header>
      <h5 class="title">ข้อมูลวิดีโอถ่ายทอดสด</h5>
    </template>
    <template v-slot:section-body v-if="currentVideo">
      <form>
        <div class="row">
          <div class="col-md-8">
            <FormGroup :errorMessage="getErrorMessage('title')">
              <h5 class="name">ชื่อ</h5>
              <input
                type="text"
                placeholder="ชื่อวิดีโอ"
                class="form-control"
                :class="{'is-invalid': getErrorMessage('title')}"
                :value="currentVideo.title"
                :disabled="currentVideo.isUsingEpisodeMetadata"
                @blur="$store.dispatch('setCurrentVideo', { title: $event.target.value })"
              />
              <div
                class="invalid-feedback"
                v-if="getErrorMessage('title')">ระบุชื่อของวิดีโอ</div>
            </FormGroup>
            <SplitRangeDateTimePicker
              :startTime="currentVideo.startLiveAt"
              :endTime="currentVideo.endLiveAt"
              @update:startTime="(startLiveAt) => $store.dispatch('setCurrentVideo', { startLiveAt })"
              @update:endTime="(endLiveAt) => $store.dispatch('setCurrentVideo', { endLiveAt })"
            />
            <FormGroup>
              <Toggle :onToggle="onToggle" :isHavingLiveChat="currentVideo.isHavingLiveChat" :label="'เปิด/ปิด แชทวิดีโอถ่ายทอดสด'"/>
            </FormGroup>
            <FormGroup>
              <h5 class="name">หมวดหมู่วิดีโอ</h5>
              <SelectOptionObject
                :placeholder="'เลือกหมวดหมู่'"
                :disabled="true"
                :value="currentVideo.category"
                :disabledDeleteButton="true"/>
            </FormGroup>
            <FormGroup>
              <h5 class="name">รายการ</h5>
              <SelectOptionObject
                :value="currentVideo.program"
                :disabled="true"
                :label="'title'"
                :placeholder="'เลือกรายการ'"
                :disabledDeleteButton="true"/>
            </FormGroup>
            <FormGroup>
              <h5 class="name">หมวดหมู่คอนเทนท์</h5>
               <SelectOptionObject
                :value="currentVideo.contentCategory"
                :options="contentCategory"
                :allowEmpty="false"
                :multiple="true"
                @onChanged="onSelectedContentCategory" />
            </FormGroup>
            <FormGroup>
              <h5 class="name">แท็ก</h5>
              <multiselect
                :value="currentVideo.tags"
                :options="tags"
                :taggable="true"
                :multiple="true"
                :addTag="addTag"
              	@onSearch="loadTags"
                @onChanged="(tags) => $store.dispatch('setCurrentVideo', { tags })" />
            </FormGroup>
            <FormGroup
              class="with-help-text"
              :errorMessage="getErrorMessage('tagline')">
              <h5 class="name">รายละเอียดอย่างสั้น</h5>
              <small class="help-text">
                คำอธิบายสั้นๆ ที่จะถูกใช้ในการแสดงตัวอย่างใน เสิร์ชเอ็นจิ้นและโซเชียลเน็ทเวิร์ค
              </small>
              <textarea
                type="text"
                rows="5"
                class="form-control"
                :class="{'is-invalid': getErrorMessage('tagline')}"
                placeholder="รายละเอียดอย่างสั้น"
                :disabled="currentVideo.isUsingEpisodeMetadata"
                :value="currentVideo.tagline"
                @input="$store.dispatch('setCurrentVideo', { tagline: $event.target.value })" />
            </FormGroup>
            <FormGroup>
              <h5 class="name">คำอธิบาย</h5>
              <HtmlEditor
                :description="currentVideo.description"
                :editable="!currentVideo.isUsingEpisodeMetadata"
                @update:description="(description) => $store.dispatch('setCurrentVideo', { description })"/>
            </FormGroup>
          </div>
          <div class="col-md-4">
            <FormGroup>
              <div class="video-container-header">
                <h5 class="name m-0">พรีวิว</h5>
                <button class="btn btn-link p-0" type="button" @click="onClickChangeVideo">เปลี่ยนลิงก์</button>
              </div>
              <ImageView
                v-if="!getEmbeddedUrl()"
                :emptyMessageText="'ยังไม่มีวิดีโอถ่ายทอดสด'"
                imageSize="cover640w360h" />
              <div
                v-if="getEmbeddedUrl() && isBytearkVideo()"
                class="player-container">
                <ByteArkPlayerContainer
                  v-if="getEmbeddedUrl()"
                  :options.sync="videoOptions"/>
              </div>
              <div
                class="video-player-container video--iframe"
                v-if="getEmbeddedUrl() && !isBytearkVideo()">
                <iframe
                  class="video-player"
                  type="text/html"
                  frameborder="0"
                  :src="`${getEmbeddedUrl()}`"/>
              </div>
            </FormGroup>
            <FormGroup>
              <h5 class="name">สถานะการเผยแพร่</h5>
              <ContentStatusManagement
                :status="currentVideo.status"
                :startPublish="currentVideo.startPublish"
                :endPublish="currentVideo.endPublish"
                :onChange="onChangeStatus" />
            </FormGroup>
            <FormGroup v-if="currentVideo && currentVideo.createdBy">
              <h5 class="name">สร้างโดย</h5>
              <EditorInformation :editor="currentVideo.createdBy" :timeStamp="currentVideo.createdAt" />
            </FormGroup>
            <FormGroup v-if="currentVideo && currentVideo.updatedBy">
              <h5 class="name">แก้ไขล่าสุดโดย</h5>
              <EditorInformation :editor="currentVideo.updatedBy" :timeStamp="currentVideo.updatedAt" />
            </FormGroup>
          </div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { loadTaxonomyByKey } from '@/taxonomy/api';
import { previewVideo } from '@/video/api';
import ByteArkPlayerContainer from '@byteark/byteark-player-vue';
import FormGroup from '@/components/FormGroup.vue';
import Section from '@/components/Section.vue';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import ContentStatusManagement from '@/contentStatus/ContentStatusManagement.vue';
import ImageView from '@/image/ImageView.vue';
import SplitRangeDateTimePicker from '@/components/SplitRangeDateTimePicker.vue';
import HtmlEditor from '@/htmlEditor/HtmlEditor.vue';
import Multiselect from '@/components/MultiSelect.vue';
import EditorInformation from '@/components/EditorInformation.vue';
import Toggle from '@/components/Toggle.vue';

// import { previewVideo } from './api';
import ManageLiveSourceModal from './ManageLiveSourceModal.vue';

export default {
  components: {
    SelectOptionObject,
    FormGroup,
    Section,
    ContentStatusManagement,
    ImageView,
    ByteArkPlayerContainer,
    ManageLiveSourceModal,
    SplitRangeDateTimePicker,
    HtmlEditor,
    Multiselect,
    EditorInformation,
    Toggle,
  },
  data() {
    return {
      videoCategories: null,
      programs: [],
      contentCategory: [],
      videoOptions: {},
      isShowChangeSourceModal: false,
      defaultVideoOptions: {
        fill: true,
        fluid: false,
        poster: '',
        sources: {},
      },
      tags: [],
    };
  },
  created() {
    this.loadContentCategories();
    this.loadTags();
    if (this.getEmbeddedUrl()) {
      this.videoOptions = {
        ...this.defaultVideoOptions,
        poster: this.getVideoCoverImage(),
        sources: this.getMediaSources(),
      };
    }
  },
  computed: {
    ...mapState({
      currentVideo: (state) => state.videoItem.currentVideo,
      saveVideoState: (state) => state.videoItem.saveVideoState,
    }),
  },
  methods: {
    async loadContentCategories() {
      const response = await loadTaxonomyByKey('content-category');
      this.contentCategory = response.data.data;
    },
    async loadTags(filter) {
      const response = await loadTaxonomyByKey('tag', filter);
      this.tags = response.data.data;
    },
    addTag(tag) {
      this.tags.push(tag);
      this.$store.dispatch('setCurrentVideo', { tags: [...this.currentVideo.tags, tag] });
    },
    onSelectedContentCategory(selectedOption) {
      if (selectedOption) {
        this.$store.dispatch('setCurrentVideo', { ...this.currentVideo, contentCategory: selectedOption, contentCategoryId: selectedOption.id });
      } else {
        this.$store.dispatch('setCurrentVideo', { contentCategory: null, contentCategoryId: null });
      }
    },
    onChangeStatus(newStatus) {
      this.$store.dispatch('setCurrentVideo', {
        ...this.currentVideo,
        status: newStatus.status,
        startPublish: newStatus.startPublish,
        endPublish: newStatus.endPublish,
      });
    },
    async onPreviewSource(media) {
      const filter = {
        type: media.type,
        sourceKey: media.sourceKey,
        sourceUrl: media.sourceUrl,
        videoType: 'live',
      };

      const response = await previewVideo(filter);
      const { embeddedUrl, canonicalUrl } = response.data;
      let newMedia = {
        sourceUrl: media.sourceUrl,
        type: media.type,
        sourceKey: media.sourceKey,
        embeddedUrl,
        videoType: 'live',
      };

      if (media.type === 'byteark') {
        newMedia = {
          ...newMedia,
          sources: [
            {
              src: media.sourceUrl,
              type: 'application/x-mpegURL',
            },
          ],
        };
      } else {
        newMedia = {
          ...newMedia,
          canonicalUrl,
        };
      }
      await this.$store.dispatch('setCurrentVideo', { media: newMedia });
      this.onCloseModal();
    },
    onDeleteVideo() {
      this.$store.dispatch('setCurrentVideo', { ...this.currentVideo, media: null });
      this.onCloseModal();
    },
    onClickChangeVideo() {
      this.isShowChangeSourceModal = true;
    },
    onCloseModal() {
      this.isShowChangeSourceModal = false;
    },
    onToggle() {
      this.$store.dispatch('setCurrentVideo', { ...this.currentVideo, isHavingLiveChat: !this.currentVideo.isHavingLiveChat });
    },
    isBytearkVideo() {
      return this.getVideoType() === 'qoder' || this.getVideoType() === 'byteark';
    },
    getVideoCoverImage() {
      return _.get(this.currentVideo, 'coverImage.urls.cover1280w720h', '');
    },
    getEmbeddedUrl() {
      // ?image=${getVideoCoverImage()};
      return _.get(this.currentVideo, 'media.embeddedUrl', '');
    },
    getMediaSources() {
      return _.get(this.currentVideo, 'media.sources', null);
    },
    getVideoType() {
      return _.get(this.currentVideo, 'media.type', '');
    },
    getErrorMessage(fieldName) {
      return _.get(this.saveVideoState.error, `${fieldName}`, null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.video-container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $spacer / 3;
}

// iFrame Player Container
.video-player-container {
  &.video--iframe {
    padding-top: 56.25%;
    width: 100%;
    position: relative;
    .video-player {
      border: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
  }
}

.live-type-selector {
  height: 40px;
}

// ByteArk Player Fill Container
.player-container {
  width: 100%;
  height: 190px;
  position: relative;
}

@media screen and (max-width: 768px) {
  // ByteArk Player Fill Container
  .player-container {
    height: 48vw;
  }
}

</style>
